import { Commit, ActionTree } from 'vuex';
import axiosInstance from '@/services/api/http.service.js';
import getEnv from '@/utils/env';
import { State } from './overview.store';

const API_URL =
  getEnv('VUE_APP_ALERT_HOST') ||
  process.env.VUE_APP_ALERT_HOST ||
  'http://localhost:63250';

const http = new axiosInstance({ auth: true });

const actions: ActionTree<State, any> = {
  async GET_CHANNELS(
    context: { commit: Commit },
    params: {
      keyword: String;
      limit: Number;
      from: Number;
      sortBy: String;
      order: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }

    try {
      const response = await http.post(
        `${API_URL}/api/v1/channels/search`,
        params
      );
      if (response && response.data && response.data.success == true) {
        context.commit('setChannels', response.data.data.notificationChannels);
        context.commit('setSearchTotalChannels', response.data.data.total);

        if (!params.keyword || params.keyword == '') {
          context.commit('setTotalChannels', response.data.data.total);
        }
      }
      throw response;
    } catch (error) {
      // Handle error
    }
  },
  async GET_ALERT_RULE_CHANNELS(
    context: { commit: Commit },
    channelId: String
  ) {
    if (!channelId) {
      return new Promise<void>(resolve => resolve());
    }

    try {
      const response = await http.post(
        `${API_URL}/api/v1/rules/names?channelId=${channelId}`
      );
      if (response && response.data && response.data.success == true) {
        context.commit(
          'setAlertRuleChannels',
          response.data.data.ruleNamesMap.ruleNames
        );
        context.commit(
          'setAlertGroupRuleChannels',
          response.data.data.ruleNamesMap.groupRuleNames
        );
        context.commit('setTotalAlertRuleChannels', response.data.data.total);
      } else {
        context.commit('setAlertRuleChannels', []);
        context.commit('setAlertGroupRuleChannels', []);
        context.commit('setTotalAlertRuleChannels', 0);
      }
    } catch (error) {
      context.commit('setAlertRuleChannels', []);
      context.commit('setAlertGroupRuleChannels', []);
      context.commit('setTotalAlertRuleChannels', 0);
    }
  },
  async DELETE_ALERT_RULE_CHANNEL(
    context: { commit: Commit },
    channelId: String
  ) {
    if (!channelId) {
      return new Promise<void>(resolve => resolve());
    }

    try {
      const response = await http.delete(
        `${API_URL}/api/v1/channels/${channelId}`
      );
      return response;
    } catch (error) {
      console.log('delete-alert-rule-channel-error', error);
    }
  },
  async SEARCH_EXISTING_NOTIFICATION_CHANNEL_NAME(
    context: { commit: Commit },
    channelName: String
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        const response = http.post(`${API_URL}/api/v1/channels/search`, {
          keyword: channelName,
          wildcard: false
        });
        if (response && response.data && response.data.success == true) {
          //
        }
        resolve(response);
      } catch (error) {
        reject(error);
        // Handle error
      }
    });
  },
  async SAVE_ALERT_RULE_CHANNEL(
    context: { commit: Commit },
    {
      channelId,
      channelName,
      type,
      values,
      createdAt,
      lastUpdatedAt,
      lastUpdatedBy,
      createdBy,
      template,
      templateType
    }
  ) {
    var _payload = {
      channelName,
      type,
      values,
      createdAt,
      lastUpdatedAt,
      lastUpdatedBy,
      createdBy,
      template,
      templateType
    };
    if (channelId) {
      _payload['channelId'] = channelId;
    }

    try {
      const response = await new http.post(
        `${API_URL}/api/v1/channels/`,
        _payload
      );
      return response.data;
    } catch (error) {
      console.log('save-or-update-channel-error', error);
    }
  }
};

export default actions;